<template>
    <v-dialog v-model="show" persistent max-width="850" hide-overlay>
        <!-- <div id="app" class="my-0 py-0"> -->
        <!-- <v-app id="inspire"> -->
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-card v-model="show">
                <v-toolbar class="py-0 my-0" dark color="blue">
                    <v-toolbar-title class="my-0 py-0">Nuevo Contacto</v-toolbar-title>
                    <div>
                        <v-btn icon @click="show = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-toolbar>
                <!-- </v-card>
                <v-card class="py-0"> -->
                <v-card-text>
                    <v-row dense>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Razón Social" dense v-model="razonSocial"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Nombre de Contacto" dense v-model="contacto"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Dirección" dense v-model="direccion"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Teléfono" dense v-model="tel"></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="12" md="12">
                            <v-text-field label="Mail" dense v-model="mail"></v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- </v-card>
                <v-card color="blue" dark tile> -->
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click.stop="guardar">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
        <!-- </v-app> -->
        <!-- </div> -->
    </v-dialog>
</template>

<script>
import moment from "moment";
import axios from "../../../src/axios-auth";
export default {
    data: (vm) => ({
        valid: false,
        lazy: false,
        razonSocial: "",
        contacto: "",
        direccion: "",
        tel: "",
        mail: "",
    }),
    props: ["visible"],
    computed: {

        show: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        vaciarModels() {
            this.razonSocial = "";
            this.contacto = "";
            this.direccion = "";
            this.tel = "";
            this.mail = "";
        },

        guardar() {
            this.$swal({
                title: "Guardar Contacto",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        razonSocial: this.razonSocial,
                        contacto: this.contacto,
                        direccion: this.direccion,
                        tel: this.tel,
                        mail: this.mail,
                    };

                    let self = this;
                    axios
                        .post("/Icssa/GuardarContacto", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Contacto guardado con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
    